export default class ApiError {
  constructor(response) {
    this.type = 'apiError';
    this.status = response.status;
  }
}
